import storage from '@/services/storage';

export const SKIP_PRIVATE_ROOM_ENTRANCE = 'skip_private_room_entrance';

export const setSkipPrivateRoomEntrance = roomName => storage.setItem(SKIP_PRIVATE_ROOM_ENTRANCE, roomName);

export const clearSkipPrivateRoomEntrance = () => storage.removeItem(SKIP_PRIVATE_ROOM_ENTRANCE);

export const canSkipPrivateRoomEntrance = roomName => storage.getItem(SKIP_PRIVATE_ROOM_ENTRANCE) === roomName;
